import 'reflect-metadata';
import { Service } from 'typedi';
import { StrategyBuilder } from '../../StrategyBuilder';
import { makeLogger } from '../../../../logger/logger';
import type { ITransformEventsNamesStrategyData } from '../../types/transform-events-names-srategy-data.type';
import { TransformEventsNamesStrategyService } from '../../TransformEventsNamesStrategyService';

const { info } = makeLogger({
  pathToCurrentFile:
    'components/strategies/services/transform-events-names-service/transform-events-names-ga-service.ts',
  loggersList: ['info'],
});

@Service({ id: 'transformEventsNamesGaStrategyService' })
export class TransformEventsNamesConfigurationBuilder extends StrategyBuilder<TransformEventsNamesStrategyService> {
  build(
    details: ITransformEventsNamesStrategyData
  ): TransformEventsNamesStrategyService {
      return new GaTransformEventsNamesStrategyService(details);
  }
}

export class GaTransformEventsNamesStrategyService extends TransformEventsNamesStrategyService {
  details;
  constructor(details: ITransformEventsNamesStrategyData) {
      super();
      this.details = details;
  }

  private fallbackConfiguration = {
    strategyType: 'transformEventsNamesGa',
    params: {
      fieldsEventMapper: {},
    },
  };

  transformEventsNames(eventToDataLayer: Object): Object {
      const transformedEvent = { ...eventToDataLayer };

      // Transform 'event' key to snake_case if it exists
      if (transformedEvent['event']) {
        transformedEvent['event'] = camelToSnakeCase(transformedEvent['event']);
      }

      // Map and transform event fields according to strategy configuration
      const fieldsEventMapper = this.details?.params?.fieldsEventMapper || {};
      Object.entries(fieldsEventMapper).forEach(([key, value]) => {
          if (key in transformedEvent) {
            transformedEvent[value as string] = transformedEvent[key];
            delete transformedEvent[key];
          }
      });

      // Transform all keys to snake_case
      Object.keys(transformedEvent).forEach((key) => {
          const newKey = camelToSnakeCase(key);
          if (key !== newKey) {
            transformedEvent[newKey] = transformedEvent[key];
            delete transformedEvent[key];
          }
      });
      return transformedEvent;
  }
}

function camelToSnakeCase(str: string): string {
    return str.replace(/([a-z])([A-Z])/g, '$1_$2').toLowerCase();
}
